import { CatAThresholdDTO, WallStructureDTORowKeyEnum } from '~/api/webservice/index';

type CatAThresholdType =
  & CatAThresholdDTO
  & Record<WallStructureDTORowKeyEnum, number>;

export class CatAThreshold implements CatAThresholdType {
  readonly rowKey: CatAThresholdDTO['rowKey'];
  readonly doubleShell: CatAThresholdDTO['doubleShell'];
  readonly external: CatAThresholdDTO['external'];
  readonly monolithic: CatAThresholdDTO['monolithic'];
  readonly height: CatAThresholdDTO['height'];
  readonly timestamp: CatAThresholdDTO['timestamp'];

  constructor (ca: CatAThresholdDTO) {
    this.rowKey = ca.rowKey;
    this.doubleShell = ca.doubleShell;
    this.external = ca.external;
    this.monolithic = ca.monolithic;
    this.height = ca.height;
    this.timestamp = ca.timestamp;
  }
}
